import { arrowBackwardIcon } from "assets/images";

const ArrowBackIcon = () => {
  return <img src={arrowBackwardIcon} alt="arrow-backward" />;
};

export default ArrowBackIcon;
